import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NoticeComponent implements OnInit {

  @Input() notifBody: string;
  @Input() divId: string;

  constructor() { }

  ngOnInit() {
  }

  close() {
    const notifDiv = document.getElementById(this.divId);
    if (notifDiv) {
      notifDiv.remove();
    }
  }
}
